import { createApiMutationHook, type IApiMutationFunction } from "../../utils/api";
import { mapRelationalValue, type RelationalValue } from "../../utils/filters";
import type { IFollowUpResource } from "../types/IFollowUpResource";

export interface IFollowUpDeleteMutationParameters {
    followUp: RelationalValue<IFollowUpResource>;
}

export type IFollowUpDeleteMutationResult = void;

export const followUpDeleteMutation: IApiMutationFunction<IFollowUpDeleteMutationParameters> = ({ followUp }) => ({
    method: "DELETE",
    url: `/follow_ups/${mapRelationalValue(followUp)}`,
});

export const useFollowUpDeleteMutation = createApiMutationHook<
    IFollowUpDeleteMutationParameters,
    IFollowUpDeleteMutationResult
>(followUpDeleteMutation);
